
import { Component, Mixins, Prop, VModel, Vue } from "vue-property-decorator";
import {
  getInvoiceStatuses,
  getInvoice,
  updateInvoice,
} from "@pazion/pazion-catalog/src/services/catalog-service";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";

import { DataTableHeader } from "vuetify";
import PazLoader from "@pazion/pazion-core/src/components/utils/PazLoader.vue";
import { formatPrice } from "@pazion/pazion-catalog/src/helpers/format";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";

@Component({
  components: {
    PazLoader,
    PazTooltipButton,
  },
  methods: {
    formatPrice,
  },
})
export default class InvoiceDetailsModal extends Mixins(PermissionService) {
  @VModel({
    default: false,
  })
  showDetailsModal!: boolean;

  @Prop()
  selectedInvoiceId?: number;

  public loading: boolean = false;
  public invoice: any = null;

  public InvoicePaymentStatuses: {
    invoicePaymentStatuses: { [key: string]: any };
    invoiceStatuses: { [key: string]: any };
  } = { invoicePaymentStatuses: null, invoiceStatuses: null };

  public headers: DataTableHeader[] = [
    { text: "id", align: "start", sortable: true, value: "id" },
    {
      text: "description",
      align: "start",
      sortable: false,
      value: "description",
    },
    { text: "amount", align: "start", sortable: true, value: "amount" },
    { text: "vat", align: "start", sortable: true, value: "vat" },
    { text: "total", align: "end", sortable: true, value: "total" },
  ];

  async getInvoiceDetails() {
    this.loading = true;
    try {
      const resp = await getInvoice(this.selectedInvoiceId, {
        expand: "customer,invoiceLine,billingAddress,shippingAddress",
      });
      if (!resp) {
        this.loading = false;
        return;
      }
      this.invoice = resp;
      this.loading = false;
    } catch (err) {
      this.loading = false;
    }
  }

  async getStatuses() {
    const statusesResp = await getInvoiceStatuses();
    if (statusesResp && statusesResp.hasOwnProperty("invoicePaymentStatuses")) {
      this.InvoicePaymentStatuses = statusesResp;
    }
  }

  //NOTE: Mutation: status
  async updateInvoiceStatus(status: string, key: string) {
    const fullId = this.invoice.id;
    const data = { id: fullId, [key]: status };
    const resp = await updateInvoice(data);
    if (!resp || !resp.hasOwnProperty("id")) {
      this.$parent.$refs.toast.show({
        message: "An error occurred, status hasn't been changed",
        icon: "mdi-close-circle",
        color: "red",
        yPosition: "top",
      });
      return;
    }
    this.$emit("updateList");
  }

  getOrderDataShippingAddress(addresType: string) {
    const currentAddress =
      this.invoice &&
      this.invoice.hasOwnProperty("id") &&
      this.invoice[addresType];
    return currentAddress
      ? `${currentAddress.name} <br /> 
      ${currentAddress.street} <br /> 
      ${currentAddress.houseNumber} <br /> 
      ${currentAddress.zipcode} <br /> 
      ${currentAddress.city}`
      : "";
  }

  get getOrderDataContact() {
    return this.invoice?.customer && this.invoice?.customer?.business
      ? this.invoice.customer?.business +
          " - " +
          this.invoice?.customer?.contact
      : this.invoice?.customer?.contact;
  }

  get getInvoiceLines() {
    return (this.invoice && this.invoice.invoiceLine) || [];
  }

  get getInvoicePaymentStatus(): string {
    return this.invoice?.payment_status || "";
  }

  get getInvoiceStatus(): string {
    return this.invoice?.status || "";
  }

  get cInvoicePaymentStatuses(): any[] {
    if (this.InvoicePaymentStatuses.invoicePaymentStatuses) {
      let statusOfSelectedPayment: string = this.getInvoicePaymentStatus;

      //console.log("current payment status", this.getInvoicePaymentStatus);

      // TODO: Shall add default value in  backend
      !statusOfSelectedPayment && (statusOfSelectedPayment = "OPEN");

      let selectableStatuses: string[] =
        this.InvoicePaymentStatuses.invoicePaymentStatuses[
          statusOfSelectedPayment
        ];

      if (
        selectableStatuses &&
        selectableStatuses.length !== 0 &&
        !selectableStatuses.includes(statusOfSelectedPayment)
      )
        selectableStatuses.push(statusOfSelectedPayment);

      if (!this.invoice?.payment_status) {
        this.invoice.payment_status = statusOfSelectedPayment;
      }

      if (Array.isArray(selectableStatuses)) {
        return selectableStatuses.map((status: string) => {
          return { status, label: status.replaceAll("_", " ") };
        });
      }
      return [];
    }
  }

  get cInvoiceStatuses(): any[] {
    if (this.InvoicePaymentStatuses.invoiceStatuses) {
      let statusOfSelectedIvncoice: string = this.getInvoiceStatus;

      if (!statusOfSelectedIvncoice) {
        return [];
      }

      const checkCurrentStatus =
        this.InvoicePaymentStatuses.invoiceStatuses.hasOwnProperty(
          this.getInvoiceStatus
        );

      //NOTE: handle empty statuses array
      if (
        (checkCurrentStatus &&
          this.InvoicePaymentStatuses.invoiceStatuses[this.getInvoiceStatus]
            .length === 0) ||
        !this.InvoicePaymentStatuses.invoiceStatuses.hasOwnProperty(
          statusOfSelectedIvncoice
        )
      ) {
        return [this.getInvoiceStatus];
      }

      let selectableStatuses: string[] =
        this.InvoicePaymentStatuses.invoiceStatuses[statusOfSelectedIvncoice];

      if (
        selectableStatuses &&
        selectableStatuses.length !== 0 &&
        !selectableStatuses.includes(statusOfSelectedIvncoice)
      )
        selectableStatuses.push(statusOfSelectedIvncoice);

      if (!this.invoice?.status) {
        this.invoice.status = statusOfSelectedIvncoice;
      }

      if (Array.isArray(selectableStatuses)) {
        return selectableStatuses.map((status: string) => {
          return { status, label: status.replaceAll("_", " ") };
        });
      }
      return [];
    }
  }

  get canEditStatus() {
    return this.hasProfileFlag("invoiceManagement.edit", true);
  }
  get canEditPaymenStatus() {
    return this.hasProfileFlag("invoicePaymentManagement.edit", true);
  }

  //NOTE: Total
  get getSubTotal() {
    return this.invoice && "tax" in this.invoice && "total" in this.invoice
      ? this.invoice?.total - this.invoice.tax
      : 0;
  }

  get getTax() {
    return this.invoice && "tax" in this.invoice && this.invoice?.tax;
  }

  get getTotal() {
    return this.invoice && "total" in this.invoice && this.invoice?.total;
  }

  get getDiscount() {
    return this.invoice && "discount" in this.invoice && this.invoice?.discount;
  }

  mounted() {
    if (this.selectedInvoiceId) {
      this.getInvoiceDetails();
      this.getStatuses();
    }
  }
} //
